import {
    Button,
    ButtonVariants,
    Modal,
    ModalProps,
} from '@tcc-online/common-components';
import { Translate } from 'react-translate.ts';
import styles from './LanguageDialog.module.scss';
import { LanguageService } from '../../../services';

interface LanguageDialogProps extends ModalProps {
    onConfirm: (locale: string) => void;
    options?: string[];
}

export default function LanguageDialog(props: LanguageDialogProps) {
    const { onConfirm, options, ...rest } = props;

    return (
        <Modal classNames={{ card: styles.modal }} {...rest}>
            <div className={styles.title}>
                <Translate>fe.common.language-unavailable</Translate>
            </div>
            <div className={styles.options}>
                {options?.map((option, index) => {
                    return (
                        <div key={index} className={styles.button}>
                            <Button
                                className={styles.button}
                                variant={ButtonVariants.positive}
                                onClick={() => onConfirm(option)}
                            >
                                {LanguageService.getLanguageName(option)}
                            </Button>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
}
